import { post } from "../../utils/Backend";
import {
  mockGetOrCreateConversation,
  mockGetSpaceCsEntryEnabled,
  mockListMessages,
  mockMarkRead,
  mockPollNewMessages,
  mockSendMessage,
} from "./CustomerServiceChatMock";
import type {
  CsChatChannel,
  CsConversationBootstrap,
  CsListMessagesResult,
  CsMessage,
  CsPollNewMessagesResult,
} from "./CustomerServiceChatTypes";

const mock = false;

const BASE = "/lark/app/customerService";

export const CustomerServiceChatApi = {
  async getOrCreateConversation(
    csChannel: CsChatChannel = "PLATFORM",
    spaceId?: string
  ): Promise<CsConversationBootstrap | string> {
    if (mock && false) {
      return mockGetOrCreateConversation();
    }
    return post<
      { csChannel?: string; spaceId?: string },
      CsConversationBootstrap
    >(`${BASE}/getOrCreateConversation`, {
      csChannel,
      spaceId: spaceId?.trim() || undefined,
    });
  },

  async getSpaceCsEntryEnabled(spaceId: string): Promise<boolean> {
    if (mock && false) {
      return mockGetSpaceCsEntryEnabled(spaceId);
    }
    const res = await post<{ spaceId: string }, { enabled?: boolean }>(
      `${BASE}/getSpaceCsEntryEnabled`,
      { spaceId }
    );
    if (typeof res === "string") return false;
    return res?.enabled !== false;
  },

  async listMessages(
    conversationId: string,
    beforeMessageId?: string | null,
    size = 30
  ): Promise<CsListMessagesResult | string> {
    if (mock && false) {
      return mockListMessages(beforeMessageId);
    }
    return post<
      { conversationId: string; beforeMessageId?: string; size?: number },
      CsListMessagesResult
    >(`${BASE}/listMessages`, {
      conversationId,
      beforeMessageId: beforeMessageId ?? undefined,
      size,
    });
  },

  async pollNewMessages(
    conversationId: string,
    afterMessageId?: string | null
  ): Promise<CsPollNewMessagesResult | string> {
    if (mock && false) {
      return mockPollNewMessages(afterMessageId);
    }
    return post<
      { conversationId: string; afterMessageId?: string },
      CsPollNewMessagesResult
    >(`${BASE}/pollNewMessages`, {
      conversationId,
      afterMessageId: afterMessageId ?? undefined,
    });
  },

  async sendMessage(
    conversationId: string,
    content: string,
    messageType: "TEXT" | "IMAGE" = "TEXT"
  ): Promise<CsMessage | string> {
    if (mock && false) {
      return mockSendMessage(content);
    }
    return post<
      { conversationId: string; content: string; messageType?: string },
      CsMessage
    >(`${BASE}/sendMessage`, { conversationId, content, messageType });
  },

  async markRead(conversationId: string): Promise<boolean | string> {
    if (mock && false) {
      return mockMarkRead();
    }
    return post<{ conversationId: string }, boolean>(
      `${BASE}/markRead`,
      { conversationId }
    );
  },

  async prepareImageUpload(
    conversationId: string,
    fileExt: string
  ): Promise<{ objectKey: string } | string> {
    if (mock && false) {
      return { objectKey: `cs/${conversationId}/mock.${fileExt}` };
    }
    return post<{ conversationId: string; fileExt: string }, { objectKey: string }>(
      `${BASE}/prepareImageUpload`,
      { conversationId, fileExt }
    );
  },
};
